import { IAutomationObject } from "../../../types"
import { schema as schemaMultistate } from '../../../Devices/MultiState/types'
import { schema as schemaMultistateSwitch } from '../../../Devices/MultiStateSwitch/types'
import { schema as schemaFault } from '../../../Devices/SensorDigitalFault/types'
import { schema as schemaAlarm } from '../../../Devices/SensorDigitalAlarm/types'
import { schema as schemaState } from '../../../Devices/SensorDigital/types'
import { GridHeaderCell } from "../../../components/Grid";
import { FlexGrid, FlexGridItem } from "baseui/flex-grid";
import { FormattedMessage } from "react-intl";
import RenderIfVisible from "react-render-if-visible";
import { AutomationObjectCard } from "../../../components/Grid/AutomationObjectCard";
import { useMemo } from "react";
import { useMediaQuery } from "../../../../hooks";

const PlantSwitchesGrid = (props: { childElements: IAutomationObject[] | undefined}) => {
    const isHighRatio = useMediaQuery("only screen and (-webkit-min-device-pixel-ratio: 1.5)");
    const columnCount = isHighRatio ? [1, 1, 2, 3] : [1, 1, 2, 4];
    
    const items = useMemo(() =>  
    props.childElements?.filter((v: any) => v.schema === schemaMultistate || v.schema === schemaMultistateSwitch || v.schema === schemaFault || v.schema === schemaAlarm || v.schema === schemaState )
    ,[props.childElements]);

    return (
        <>
            {items && items.length > 0 &&
                <>
                    <GridHeaderCell header={<FormattedMessage id="P_AirHandling.Plantswitch" defaultMessage="Plantswitch" />}></GridHeaderCell>

                    <FlexGrid
                        flexGridColumnCount={columnCount}
                        flexGridColumnGap="scale800"
                        flexGridRowGap="scale800"
                    >
                        {items?.map((item: any, index: number) => (
                            (item.schema === schemaMultistateSwitch) ?

                                (<FlexGridItem >
                                    <RenderIfVisible defaultHeight={400} visibleOffset={500} stayRendered>
                                        <AutomationObjectCard item={item}></AutomationObjectCard>
                                    </RenderIfVisible>
                                </FlexGridItem>)

                                : (<></>)
                        ))}
                        {items?.map((item: any, index: number) => (
                            (item.schema === schemaMultistate ) ?

                                (<FlexGridItem >
                                    <RenderIfVisible defaultHeight={400} visibleOffset={500} stayRendered>
                                        <AutomationObjectCard item={item}></AutomationObjectCard>
                                    </RenderIfVisible>
                                </FlexGridItem>)

                                : (<></>)
                        ))}
                        {items?.map((item: any, index: number) => (
                            (item.schema === schemaFault || item.schema === schemaAlarm || item.schema === schemaState ) ?

                                (<FlexGridItem >
                                    <RenderIfVisible defaultHeight={400} visibleOffset={500} stayRendered>
                                        <AutomationObjectCard item={item}></AutomationObjectCard>
                                    </RenderIfVisible>
                                </FlexGridItem>)

                                : (<></>)
                        ))}
                    </FlexGrid>
                </>
            }
        </>
    )
}

export default PlantSwitchesGrid;